import React from "react"
import { FlagsIconSeeker, ImageSeeker, IconSeeker } from "@ui-seeker/core"
import { Box, Typography } from "@mui/material"


export default function AppRetailerBlock({ retailer, country, icon, provider, mainName, sx={} }) {
	return <><Box sx={{ display: 'flex', alignItems: 'center', gap: .5, minWidth: 0, ...sx }}>
		{ icon && <ImageSeeker
			src={`/logos/${icon}`}
			height={16}
			width={16} sx={{ mt: .3 }}
			alt={retailer}
		/> }
		<FlagsIconSeeker countryName={country} />
		<Typography variant="subtitle2" sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{retailer}</Typography>
		{ provider && <IconSeeker icon='square-parking' color='blue' iconWeight="light" sx={{ fontSize: '18px' }} /> }
	</Box>
	<Box>
		{ mainName && <Typography sx={{ fontSize: '0.8rem', color: 'gray', ml: '1rem' }}>
			Comparing vs <Typography variant='span' sx={{ fontStyle: 'italic', fontWeight: '600' }}>{ mainName }</Typography>
		</Typography> }
	</Box></>
}